<template>
  <div>
    <div style="width: 1700px; padding: 15px 0">
      <div
        style="
          width: 1640px;
          margin: 0 15px;
          padding: 15px;
          background-color: var(--vtm-well);
          display: flow-root;
          border: 1px solid var(--vtm-line);
          border-radius: 3px;
          font-weight: normal;
        "
      >
        <div class="el-left" style="line-height: 32px; height: 30px; font-size: 15px">
          {{ $t("MachineProfit.sbsytj") }}
        </div>
        <div class="el-right">
          <el-button
            type="primary"
            @click="ExportMachineData"
            size="small"
            icon="el-icon-download"
            style="margin-right: 15px"
            >{{ $t("common.export") }}</el-button
          >
          <el-input
            v-if="isMer"
            :placeholder="$t('TimeControl.userAccount')"
            v-model="userName"
            clearable
            style="width: 200px; margin-right: 15px"
            size="small"
            @blur="handlerUsernameBlur"
          ></el-input>
          <!-- 懒加载select -->
          <el-select
            collapse-tags
            multiple
            :multiple-limit="10"
            v-model.trim="allMachine"
            v-el-select-loadmore="handleLoadmore"
            filterable
            remote
            :remote-method="handleAttrValueFilter"
            size="small"
            style="width: 200px; margin-right: 15px"
            :placeholder="$t('MachineProfit.qbjiqi')"
          >
            <el-option
              v-for="item in options"
              :key="item.equipmentNo"
              :label="item.equipmentName"
              :value="item.equipmentNo"
            >
            </el-option>
          </el-select>
          <!-- 懒加载select -->
          <el-select
            collapse-tags
            multiple
            :multiple-limit="10"
            v-model.trim="allShop"
            v-el-select-loadmore="handleLoadmore2"
            filterable
            remote
            :remote-method="handleAttrValueFilter2"
            size="small"
            style="width: 200px; margin-right: 15px"
            :placeholder="$t('MachineProfit.qbshpin')"
          >
            <el-option
              v-for="(item, index) in optionsShop"
              :key="item && item.id ? item.id : index"
              :label="item && item.name ? item.name : ''"
              :value="item && item.id ? item.id : null"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="search.searchType"
            :placeholder="$t('MachineProfit.select')"
            size="small"
            style="width: 170px; margin-right: 15px"
          >
            <el-option :label="$t('MachineProfit.xsliang')" value="num"></el-option>
            <el-option :label="$t('MachineProfit.xshoue')" value="sales"></el-option>
          </el-select>
          <el-select
            v-model="search.dayType"
            @change="handlerDayTypeChange"
            :placeholder="$t('MachineProfit.select')"
            size="small"
            style="width: 120px; margin-right: 15px"
          >
            <el-option :label="$t('DateProfit.antian')" :value="1"></el-option>
            <el-option :label="$t('DateProfit.anyue')" :value="2"></el-option>
          </el-select>
          <el-date-picker
            v-if="search.dayType == 1"
            v-model="dateTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            size="small"
            clearable
            :start-placeholder="$t('searchMachineProfit.start')"
            :end-placeholder="$t('searchMachineProfit.end')"
            style="margin-right: 15px; width: 280px"
          ></el-date-picker>
          <el-date-picker
            v-if="search.dayType == 2"
            v-model="dateTime"
            type="monthrange"
            value-format="yyyy-MM"
            size="small"
            :range-separator="$t('MachineProfit.to')"
            :start-placeholder="$t('MachineProfit.startmonth')"
            :end-placeholder="$t('MachineProfit.endmonth')"
            :placeholder="$t('MachineProfit.showdate')"
            style="margin-right: 15px; width: 280px"
          ></el-date-picker>
          <el-button type="primary" @click="handlerSubmitSearch(1)" size="small" icon="el-icon-search">{{
            $t("common.search")
          }}</el-button>
          <el-button @click="handlerResetSearch(1)" size="small" icon="el-icon-refresh">{{
            $t("common.reset")
          }}</el-button>
        </div>
      </div>
    </div>
    <!-- 表 -->
    <div style="width: 1670px; margin: 20px 15px 0 15px; display: flex; justify-content: center; align-items: center">
      <div id="mpchart"></div>
      <div id="mpdchart"></div>
    </div>
    <div style="width: 1670px; margin: 30px 15px 0 15px; display: flex; justify-content: center; align-items: center">
      <div style="position: relative">
        <div id="lztchart"></div>
        <div style="position: absolute; top: 5px; right: 0px">
          <el-select
            v-model="search.equipmentTop"
            :placeholder="$t('MachineProfit.select')"
            @change="MachineRankChart"
            size="small"
            style="width: 160px; margin-right: 40px"
          >
            <el-option :label="$t('MachineProfit.sbqian1')" value="20"></el-option>
            <el-option :label="$t('MachineProfit.sbqian2')" value="10"></el-option>
            <el-option :label="$t('MachineProfit.sbqian3')" value="5"></el-option>
            <el-option :label="$t('MachineProfit.sbqian4')" value="3"></el-option>
          </el-select>
        </div>
      </div>
      <div style="position: relative">
        <div id="rztchart"></div>
        <div style="position: absolute; top: 5px; right: 20px">
          <el-select
            v-model="localMachineNo"
            :placeholder="$t('MachineProfit.select')"
            @change="MachineProductRankChart"
            size="small"
            style="width: 180px; margin-left: 10px"
          >
            <el-option
              v-for="(machine, index) in MachineNoNames"
              :key="index"
              :label="machine.equipmentName"
              :value="machine.equipmentNo"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <!-- radius -->
    <div class="vue-padding" style="margin-top: 30px">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="machineProfitList"
        show-summary
        :summary-method="getSummaries"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column
          prop="equipmentName"
          :label="$t('machineOrder.equipmentName')"
          :show-overflow-tooltip="true"
          :align="'center'"
        ></el-table-column>
        <el-table-column prop="equipmentNo" :label="$t('machineOrder.equipmentNo')" :align="'center'"></el-table-column>
        <el-table-column
          prop="productnum"
          :label="$t('MachineProfit.productTotalNum')"
          :align="'center'"
        ></el-table-column>
        <el-table-column prop="num" :label="$t('MachineProfit.totalNum')" :align="'center'"></el-table-column>
        <el-table-column prop="sales" :label="$t('MachineProfit.totalSales')" :align="'center'" :formatter="(row) => $currency(row.sales)"></el-table-column>
        <el-table-column prop="cost" :label="$t('MachineProfit.totalCost')" :align="'center'" :formatter="(row) => $currency(row.cost)"></el-table-column>
        <el-table-column prop="profit" :label="$t('MachineProfit.totalProfit')" :align="'center'" :formatter="(row) => $currency(row.profit)"></el-table-column>
        <el-table-column prop="margin" :label="$t('MachineProfit.margin')" :align="'center'"
          :formatter="(row) => row.sales > 0 ? (row.profit / row.sales * 100).toFixed(1) + '%' : '—'">
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="page.totalSize > 0"
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import * as echarts from "echarts";
  import { chartThemeName } from "@/utils/macarons";
  import { formatDate } from "../../common/formatDate";
  var mpchart = null;
  let mpdchart = null;
  let lztchart = null;
  let rztchart = null;
  export default {
    name: "MachineProfit",
    directives: {
      "el-select-loadmore": {
        //自定义指令
        bind(el, binding) {
          const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
          SELECTWRAP_DOM.addEventListener("scroll", function () {
            const condition = this.scrollHeight - this.scrollTop - 15 <= this.clientHeight;
            if (condition) {
              binding.value();
            }
          });
        }
      }
    },
    data() {
      return {
        //  设备分组下拉
        search: {
          searchType: "sales",
          searchType1: "sales",
          dayType: 1,
          dayType1: 3,
          equipmentNos: [],
          productIds: [],
          equipmentTop: "20"
        },
        dateTime: [],
        dateTime1: [],
        localMachineNo: "",
        MachineNoNames: [],
        lztmachines: [],
        userName: "",
        username2: "",
        MachinesValue: [],
        DefaultProps: {
          children: "children",
          label: "name",
          isLeaf: "leaf"
        },
        ProductsValue: [],
        //  列表数据
        machineProfitList: [],
        page: {
          pageSize: 10,
          pageIndex: 1,
          totalSize: 0
        },
        loading: false,
        order: {},
        lsearch: {
          equipmentNos: [],
          productIds: []
        },
        isMer: false,
        // 懒加载select1
        allMachine: [],
        allShop: [],
        selectObj: {
          pageNum: 1,
          pageSize: 10,
          name: ""
        },
        selectObj2: {
          pageNum: 1,
          pageSize: 10,
          name: ""
        },
        options: [],
        optionsShop: [],
        selectLoading: false,
        lock: true,
        lock2: true
      };
    },

    mounted() {
      let _self = this;
      if (localStorage.utype == 4) {
        this.isMer = true;
      }
      _self.getDateString(parseInt(_self.search.dayType));
      _self.getDateString(parseInt(_self.search.dayType1));
      mpchart = echarts.init(document.getElementById("mpchart"), chartThemeName(), {
        width: 500,
        height: 450
      });
      mpdchart = echarts.init(document.getElementById("mpdchart"), chartThemeName(), {
        width: 1170,
        height: 450
      });
      lztchart = echarts.init(document.getElementById("lztchart"), chartThemeName(), {
        width: 900,
        height: 400
      });
      rztchart = echarts.init(document.getElementById("rztchart"), chartThemeName(), {
        width: 770,
        height: 400
      });
      _self.MachinePercentageChart();
      _self.MachineRankChart();
      _self.currentChange();
      // 首次请求options
      _self.handlerGetSelect();
      _self.handlerGetSelect2();
    },
    methods: {
      // 鼠标移出用户账号输入框
      handlerUsernameBlur() {
        this.selectObj.pageNum = 1;
        this.selectObj2.pageNum = 1;
        this.handlerGetSelect();
        this.handlerGetSelect2();
      },
      handleLoadmore() {
        //下拉加载
        if (!this.selectLoading) {
          this.handlerGetSelect();
        }
      },
      handleAttrValueFilter(name) {
        //搜索
        this.options = [];
        if (!this.selectLoading) {
          this.selectObj.name = name;
          this.selectObj.pageNum = 1;
          this.handlerGetSelect();
        }
      },
      // 请求options
      handlerGetSelect() {
        let that = this;
        if (this.lock) {
          //节流
          that.lock = false;
          let timer = setTimeout(() => {
            clearTimeout(timer);
            that.lock = true;
          }, 300);
        } else {
          return;
        }
        let url = this.$url.Machine.select;
        let method = this.$method.get;
        let params = {
          pageIndex: this.selectObj.pageNum,
          pageSize: this.selectObj.pageSize,
          searchName: this.selectObj.name,
          userName: this.userName
        };
        this.$api.request(url, method, params).then(res => {
          if (res.code === 0) {
            if (res.data && res.data.records && res.data.records.length > 0) {
              this.selectObj.pageNum++;
            }
            if (res.data && res.data.current == 1) {
              this.options = res.data.records || [];
            } else if (res.data && res.data.records) {
              this.options = this.options.concat(res.data.records);
            }
            if (res.data) {
              this.selectObj.pageSize = res.data.size;
            }
          }
        });
      },
      handleLoadmore2() {
        //下拉加载
        if (!this.selectLoading) {
          this.handlerGetSelect2();
        }
      },
      handleAttrValueFilter2(name) {
        //搜索
        this.optionsShop = [];
        if (!this.selectLoading) {
          this.selectObj2.name = name;
          this.selectObj2.pageNum = 1;
          this.handlerGetSelect2();
        }
      },
      // 请求options
      handlerGetSelect2() {
        let that = this;
        if (this.lock2) {
          //节流
          that.lock2 = false;
          let timer = setTimeout(() => {
            clearTimeout(timer);
            that.lock2 = true;
          }, 300);
        } else {
          return;
        }
        let url = this.$url.Product.select;
        let method = this.$method.get;
        let params = {
          pageIndex: this.selectObj2.pageNum,
          pageSize: this.selectObj2.pageSize,
          searchName: this.selectObj2.name,
          userName: this.userName
        };
        this.$api.request(url, method, params).then(res => {
          if (res.code === 0) {
            if (res.data && res.data.records && res.data.records.length > 0) {
              this.selectObj2.pageNum++;
            }
            if (res.data && res.data.current == 1) {
              this.optionsShop = res.data.records || [];
            } else if (res.data && res.data.records) {
              this.optionsShop = this.optionsShop.concat(res.data.records);
            }
            if (res.data) {
              this.selectObj2.pageSize = res.data.size;
            }
          }
        });
      },
      //  机器占比图+收益统计
      MachinePercentageChart() {
        let _self = this;
        let params = {
          searchType: _self.search.searchType,
          type: _self.search.dayType == 1 ? 1 : 2
        };
        if (_self.dateTime && _self.dateTime.length > 0) {
          if (_self.search.dayType == 1) {
            params.startDate = formatDate(_self.dateTime[0], "yyyy-MM-dd");
            params.endDate = formatDate(_self.dateTime[1], "yyyy-MM-dd");
          } else {
            params.startDate = _self.dateTime[0];
            params.endDate = _self.dateTime[1];
          }
        }
        if (_self.allMachine.length > 0) {
          params.equipmentNos = _self.allMachine.join(",");
        }
        if (_self.allShop.length > 0) {
          params.productIds = _self.allShop.join(",");
        }
        // 如果有usernmae
        if (_self.userName) {
          params.userName = _self.userName;
        }
        let url = this.$url.MachineProfit.statisticsday;
        let method = this.$method.get;
        mpchart.showLoading();
        mpdchart.showLoading();
        _self.$api.request(url, method, params).then(res => {
          if (res.data) {
            //  设备占比图
            if (res.data.sales && res.data.sales.length > 0) {
              let machines = res.data.sales;
              //  基于准备好的dom，初始化echarts实例
              var mpchartData = [];
              for (let i = 0; i < machines.length; i++) {
                var sales =
                  parseFloat(machines[i][_self.search.searchType]) < 0
                    ? 0
                    : parseFloat(machines[i][_self.search.searchType]);
                var idata = {
                  value: sales,
                  name: machines[i]["equipmentName"]
                };
                mpchartData.push(idata);
              }
              var mpTotal = mpchartData.reduce(function(sum, d) { return sum + d.value; }, 0);
              var isSalesRevenue = _self.search.searchType === "sales";
              var mpChartTitle = isSalesRevenue
                ? _self.$t("MachineProfit.xshoue")
                : _self.$t("MachineProfit.xsliang");
              var mpTotalText = isSalesRevenue
                ? _self.$currency(mpTotal)
                : mpTotal.toLocaleString();
              var mpchartoption = {
                title: {
                  text: mpChartTitle,
                  subtext: "",
                  left: "center"
                },
                tooltip: {
                  trigger: "item",
                  formatter: function(p) {
                    var val = isSalesRevenue ? _self.$currency(p.value) : p.value.toLocaleString();
                    return p.name + ": " + val + " (" + p.percent + "%)";
                  }
                },
                graphic: {
                  type: "text",
                  left: "center",
                  top: "center",
                  style: {
                    text: "Total\n" + mpTotalText,
                    textAlign: "center",
                    fill: "#1a1f36",
                    fontSize: 13,
                    fontWeight: "bold",
                    lineHeight: 20
                  }
                },
                series: [
                  {
                    name: _self.$t("consoles.sbsy"),
                    type: "pie",
                    radius: ["30%", "55%"],
                    data: mpchartData,
                    emphasis: {
                      itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)"
                      }
                    }
                  }
                ]
              };

              mpchart.clear();
              mpchartoption && mpchart.setOption(mpchartoption);
            } else {
              mpchart.clear();
              if (!res.data.day || Object.keys(res.data.day).length === 0) {
                mpchart.setOption(_self.emptyChartOption(_self.search.searchType === "sales" ? _self.$t("MachineProfit.xshoue") : _self.$t("MachineProfit.xsliang")));
              }
            }

            //  设备走向图
            if (res.data.day && Object.keys(res.data.day).length > 0) {
              //  获取所有键赋值日期
              let dateset = [];
              Object.keys(res.data.day).forEach(key => {
                dateset.push(key);
              });
              //  获取所有键值赋值设备
              let machines = [];
              let machineseries = [];
              Object.values(res.data.day).forEach((val, key) => {
                if (key == 0) {
                  //  遍历设备
                  for (let i = 0; i < val.length; i++) {
                    let equipmentNo = val[i]["equipmentNo"];
                    let equipmentName = val[i]["equipmentName"] || "";
                    let item = {
                      name: equipmentName || "",
                      type: "line",
                      data: []
                    };
                    machines.push(equipmentName);
                    Object.values(res.data.day).forEach(vals => {
                      //  遍历设备
                      let num = 0;
                      for (let j = 0; j < vals.length; j++) {
                        let equipmentNos = vals[j]["equipmentNo"];
                        if (equipmentNo == equipmentNos) {
                          num = vals[j][_self.search.searchType];
                        }
                      }
                      item.data.push(num);
                    });
                    machineseries.push(item);
                  }
                }
              });
              let mpdoption = {
                title: {
                  text: _self.$t("MachineProfit.sbzxt"),
                  subtext: "Real-time data",
                  left: "center"
                },
                // 保存图片按钮
                toolbox: {
                  feature: {
                    saveAsImage: {}
                  }
                },
                tooltip: {
                  trigger: "axis",
                  formatter: function(params) {
                    const isSales = _self.search.searchType === "sales";
                    let result = params[0].axisValueLabel + "<br/>";
                    params.forEach(function(p) {
                      result += p.marker + p.seriesName + ": " + (isSales ? _self.$currency(p.value) : p.value) + "<br/>";
                    });
                    return result;
                  }
                },
                legend: {
                  data: machines,
                  top: "bottom"
                },
                xAxis: {
                  type: "category",
                  boundaryGap: false,
                  data: dateset
                },
                yAxis: {
                  type: "value"
                },
                series: machineseries
              };

              mpdchart.clear();
              mpdoption && mpdchart.setOption(mpdoption);
            } else {
              mpdchart.clear();
              if (!res.data.sales || res.data.sales.length === 0) {
                mpdchart.setOption(_self.emptyChartOption(_self.$t("MachineProfit.sbzxt")));
              }
            }
          }

          mpchart.hideLoading();
          mpdchart.hideLoading();
        });
      },
      //  机器排行榜统计
      MachineRankChart() {
        let _self = this;
        let params = {
          type: _self.search.dayType,
          searchType: _self.search.searchType,
          order: "desc",
          equipmentTop: parseInt(_self.search.equipmentTop),
          goodsTop: 10
        };
        let url = this.$url.MachineProfit.statisticstop;
        let method = this.$method.get;
        if (_self.dateTime && _self.dateTime.length > 0) {
          if (_self.search.dayType == 1) {
            params.startDate = formatDate(_self.dateTime[0], "yyyy-MM-dd");
            params.endDate = formatDate(_self.dateTime[1], "yyyy-MM-dd");
          } else {
            params.startDate = _self.dateTime[0];
            params.endDate = _self.dateTime[1];
          }
        }
        if (_self.userName) {
          params.userName = _self.userName;
        }
        lztchart.showLoading();
        _self.$api
          .request(url, method, params)
          .then(res => {
            //  左侧走向图
            if (res.data && res.data.length > 0) {
                let lztmachines = res.data;
                _self.localMachineNo = lztmachines[0]["equipmentNo"];
                _self.lztmachines = lztmachines;
                //  基于准备好的dom，初始化echarts实例
                var MachineNoNames = [];
                var lztXAxisData = [];
                var lztSeriesData = [];
                for (let i = 0; i < lztmachines.length; i++) {
                  var lztTotalSales =
                    parseFloat(lztmachines[i][_self.search.searchType]) < 0
                      ? 0
                      : parseFloat(lztmachines[i][_self.search.searchType]);
                  lztXAxisData.push(lztmachines[i]["equipmentName"]);
                  lztSeriesData.push(lztTotalSales);
                  MachineNoNames.push({
                    equipmentNo: lztmachines[i]["equipmentNo"],
                    equipmentName: lztmachines[i]["equipmentName"]
                  });
                }
                _self.MachineNoNames = MachineNoNames;
                _self.MachineProductRankChart();
                let lztoption = {
                  title: {
                    text: _self.$t("MachineProfit.sbzztu")
                  },
                  tooltip: {
                    trigger: "axis",
                    axisPointer: {
                      type: "shadow"
                    }
                  },
                  grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true
                  },
                  xAxis: [
                    {
                      type: "category",
                      data: lztXAxisData,
                      axisTick: {
                        alignWithLabel: true
                      },
                      axisLabel: { interval: 0, rotate: 20 }
                    }
                  ],
                  yAxis: [
                    {
                      type: "value"
                    }
                  ],
                  series: [
                    {
                      name:
                        _self.search.searchType == "num"
                          ? _self.$t("MachineProfit.xsliang")
                          : _self.$t("MachineProfit.xshoue"),
                      type: "bar",
                      barWidth: "40%",
                      data: lztSeriesData
                    }
                  ]
                };
                lztchart.clear();
                lztoption && lztchart.setOption(lztoption);
              } else {
                lztchart.clear();
                lztchart.setOption(_self.emptyChartOption(_self.$t("MachineProfit.sbzztu")));
                rztchart.clear();
                rztchart.setOption(_self.emptyChartOption(_self.$t("MachineProfit.sbspzztu")));
            }
          })
          .finally(() => {
            lztchart.hideLoading();
          });
      },
      //  根据设备查看商品排行榜
      MachineProductRankChart() {
        let _self = this;
        if (_self.localMachineNo) {
          rztchart.showLoading();
          let localMachineNo = _self.localMachineNo;
          let lztmachines = _self.lztmachines;
          let rztproducts = [];
          for (let i = 0; i < lztmachines.length; i++) {
            if (lztmachines[i]["equipmentNo"] == localMachineNo) {
              rztproducts = lztmachines[i]["productStat"];
            }
          }
          if (rztproducts && rztproducts.length > 0) {
            //  基于准备好的dom，初始化echarts实例
            var rztXAxisData = [];
            var rztSeriesData = [];
            for (let i = 0; i < rztproducts.length; i++) {
              var rztTotalSales =
                parseFloat(rztproducts[i][_self.search.searchType]) < 0
                  ? 0
                  : parseFloat(rztproducts[i][_self.search.searchType]);
              rztXAxisData.push(rztproducts[i]["goodsName"]);
              rztSeriesData.push(rztTotalSales);
            }
            let rztoption = {
              title: {
                text: _self.$t("MachineProfit.sbspzztu")
              },
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow"
                }
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true
              },
              xAxis: {
                type: "value"
              },
              yAxis: {
                type: "category",
                data: rztXAxisData,
                axisLabel: { interval: 0, rotate: 50 }
              },
              series: [
                {
                  name:
                    _self.search.searchType == "num"
                      ? _self.$t("MachineProfit.xsliang")
                      : _self.$t("MachineProfit.xshoue"),
                  type: "bar",
                  data: rztSeriesData
                }
              ]
            };
            rztchart.clear();
            rztoption && rztchart.setOption(rztoption);
          } else {
            rztchart.clear();
            rztchart.setOption(_self.emptyChartOption(_self.$t("MachineProfit.sbspzztu")));
          }
          rztchart.hideLoading();
        }
      },
      emptyChartOption(title) {
        return {
          title: { text: title, left: "center" },
          graphic: {
            type: "text",
            left: "center",
            top: "middle",
            style: { text: "No data available", fontSize: 14, fill: "#999" }
          },
          series: []
        };
      },
      //  获取开始日期时间和结束日期时间
      handlerDayTypeChange(e) {
        let _self = this;
        _self.getDateString(parseInt(e));
      },
      getDateString(nums) {
        let _self = this;
        if (nums == 1 || nums == 3) {
          let myDate = new Date();
          //  当前时间年月日时分秒
          let year = myDate.getFullYear();
          let month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          let day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          let hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          let minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          let second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          let enddatetime = year + "-" + month + "-" + day;
          //  30天前的时间
          let ddstian = 30;
          myDate.setTime(myDate.getTime() - 24 * ddstian * 60 * 60 * 1000);
          year = myDate.getFullYear();
          month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          //  获取统计数据
          let startdatetime = year + "-" + month + "-" + day;
          if (nums == 1) {
            _self.dateTime = [startdatetime, enddatetime];
          } else if (nums == 3) {
            _self.dateTime1 = [startdatetime, enddatetime];
          }
        } else if (nums == 2 || nums == 4) {
          //  结束日期
          let myDate = new Date();
          let year = myDate.getFullYear();
          let month = myDate.getMonth() + 1;
          month = month < 10 ? "0" + month : month;
          let enddate = year + "-" + month;
          //  开始日期
          myDate.setTime(myDate.getTime() - 24 * 30 * 12 * 60 * 60 * 1000);
          year = myDate.getFullYear();
          month = myDate.getMonth() + 1;
          month = month < 10 ? "0" + month : month;
          let startdate = year + "-" + month;
          if (nums == 2) {
            _self.dateTime = [startdate, enddate];
          } else if (nums == 4) {
            _self.dateTime1 = [startdate, enddate];
          }
          return;
        }
      },
      //  指定列求和
      getSummaries(param) {
        const { columns } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = <span style="font-weight: bold;">{this.$t("machineRenewal.total")}</span>;
            return;
          }
          if (column.property === "num") {
            sums[index] = <span style="font-weight: bold;">{this.order.num}</span>;
          } else if (column.property === "sales") {
            sums[index] = <span style="font-weight: bold;">{this.$currency(this.order.sales)}</span>;
          } else if (column.property === "cost") {
            sums[index] = <span style="font-weight: bold;">{this.$currency(this.order.cost)}</span>;
          } else if (column.property === "profit") {
            sums[index] = <span style="font-weight: bold;">{this.$currency(this.order.profit)}</span>;
          } else if (column.property === "margin") {
            const m = this.order.sales > 0 ? (this.order.profit / this.order.sales * 100).toFixed(1) + '%' : '—';
            sums[index] = <span style="font-weight: bold;">{m}</span>;
          }
        });
        return sums;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      //  加载设备数据表
      currentChange(pageIndex) {
        let _self = this;
        _self.loading = true;
        _self.page.pageIndex = pageIndex ? pageIndex : 1;
        if (_self.search.equipmentNos.length > 0) {
          _self.lsearch.equipmentNos = _self.search.equipmentNos.join(",");
        }
        if (_self.search.productIds.length > 0) {
          _self.lsearch.productIds = _self.search.productIds.join(",");
        }
        let obj = _self.$cloud.objMerge(_self.lsearch, _self.page);

        obj.type = _self.search.dayType;
        obj.searchType = _self.search.searchType;
        if (_self.dateTime && _self.dateTime.length > 0) {
          if (_self.search.dayType == 1) {
            obj.startDate = formatDate(_self.dateTime[0], "yyyy-MM-dd");
            obj.endDate = formatDate(_self.dateTime[1], "yyyy-MM-dd");
          } else {
            obj.startDate = _self.dateTime[0];
            obj.endDate = _self.dateTime[1];
          }
        }
        _self.$api
          .request(_self.$url.MachineProfit.statisticstable, _self.$method.get, obj)
          .then(res => {
            if (res.data) {
              _self.machineProfitList = res.data.records;
              _self.page.totalSize = parseInt(res.data.total);
              _self.order = res.data.sum;
            }
          })
          .finally(() => {
            _self.loading = false;
          });
      },
      //  重置搜索
      handlerResetSearch(type) {
        let _self = this;
        if (type == 1) {
          _self.search.searchType = "sales";
          _self.search.dayType = 1;
          _self.allShop = [];
          _self.allMachine = [];
          _self.MachinesValue = [];
          _self.ProductsValue = [];
          _self.userName = "";
          _self.getDateString(parseInt(_self.search.dayType));
          _self.MachinePercentageChart();
          _self.currentChange();
        } else if (type == 2) {
          _self.search.searchType1 = "num";
          _self.search.dayType1 = 3;
          _self.username2 = "";
          _self.getDateString(parseInt(_self.search.dayType1));
          _self.MachineRankChart();
        }
      },
      // 筛选时间是按天与日期关联
      handlerDateIsOk(type, dateArr) {
        if (type % 2 === 1) {
          // 按天
          if (!dateArr) {
            this.$message.warning(this.$t("DateProfit.kuaduDay"));
            return false;
          }
          // 按天时间跨度不能超过90天
          let kuadu = new Date(dateArr[1]).getTime() - new Date(dateArr[0]).getTime();
          if (kuadu >= 7776000000) {
            this.$message.warning(this.$t("DateProfit.kuaduDay"));
            return false;
          }
        } else if (type % 2 == 0) {
          // 按月
          if (!dateArr) {
            this.$message.warning(this.$t("DateProfit.kuaduMonth"));
            return false;
          }
          // 按天时间跨度不能超过90天
          let kuadu = new Date(dateArr[1]).getTime() - new Date(dateArr[0]).getTime();
          if (kuadu >= 157680000000) {
            this.$message.warning(this.$t("DateProfit.kuaduMonth"));
            return false;
          }
        }
        return true;
      },
      //  提交搜索
      handlerSubmitSearch(type) {
        let _self = this;
        let bol = null;
        if (type == 1) {
          bol = _self.handlerDateIsOk(_self.search.dayType, _self.dateTime);
        } else if (type == 2) {
          bol = _self.handlerDateIsOk(_self.search.dayType1, _self.dateTime1);
        }
        if (!bol) return false;
        if (type == 1) {
          //  机器分组
          let MachinesValue = _self.MachinesValue;
          _self.search.equipmentNos = [];
          for (let i = 0; i < MachinesValue.length; i++) {
            if (MachinesValue[i] && MachinesValue[i].id !== undefined) {
              _self.search.equipmentNos.push(MachinesValue[i].id);
            }
          }
          //  商品分组
          let ProductsValue = _self.ProductsValue;
          _self.search.productIds = [];
          for (let i = 0; i < ProductsValue.length; i++) {
            if (ProductsValue[i] && ProductsValue[i].id !== undefined) {
              _self.search.productIds.push(ProductsValue[i].id);
            }
          }
          _self.MachinePercentageChart();
          _self.MachineRankChart();
          _self.currentChange();
        } else if (type == 2) {
          _self.MachineRankChart();
          _self.currentChange();
        }
      },
      //  设备数据表导出
      ExportMachineData() {
        let _self = this;
        _self
          .$confirm(_self.$t("MachineProfit.export"), _self.$t("common.tip"), {
            confirmButtonText: _self.$t("common.definite"),
            cancelButtonText: _self.$t("common.cancel"),
            type: "warning"
          })
          .then(() => {
            let rData = {};
            if (_self.userName) {
              rData.userName = _self.userName;
            }
            if (_self.allMachine.length > 0) {
              rData.equipmentNos = _self.allMachine;
            }
            if (_self.allShop.length > 0) {
              rData.productIds = _self.allShop;
            }
            if (_self.search.searchType) {
              rData.searchType = _self.search.searchType;
            }
            if (_self.search.dayType) {
              rData.type = _self.search.dayType;
            }
            if (_self.dateTime && _self.dateTime.length > 0) {
              rData.startDate = _self.dateTime[0];
              rData.endDate = _self.dateTime[1];
            }
            let bol = _self.handlerDateIsOk(_self.search.dayType, _self.dateTime);
            if (!bol) return false;
            rData.lang = this.$cookies.get("lang");
            _self.$api.download(_self.$url.MachineProfit.export, rData);
          });
      }
    }
  };
</script>
